import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form__field form-files" }
const _hoisted_2 = ["name", "id", "accept", "multiple", "aria-invalid", "aria-describedby"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "form__indicator"
}
const _hoisted_5 = {
  key: 1,
  class: "form__tooltip"
}
const _hoisted_6 = {
  key: 2,
  class: "btn"
}
const _hoisted_7 = {
  key: 0,
  class: "form-files__files"
}
const _hoisted_8 = { class: "form-files__name" }
const _hoisted_9 = ["onClick", "aria-label"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "plus-sign plus-sign--plus plus-sign--minus" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "form-files__files"
}
const _hoisted_13 = { class: "form-files__name" }
const _hoisted_14 = ["onClick", "aria-label"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "plus-sign plus-sign--plus plus-sign--minus" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["id"]

import { Status } from "@/validation";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue3-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormFiles',
  props: {
    name: {},
    label: {},
    modelValue: {},
    tooltip: {},
    min: {},
    max: {},
    isMultiple: { type: Boolean },
    possiblesTypes: {},
    defaultSelectedFiles: {},
    canDelete: { type: Boolean }
  },
  emits: ["update:modelValue", "validated", "on-default-selected-files-change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = useI18n();

// eslint-disable-next-line
const props = __props;

// eslint-disable-next-line
__expose({
  //to call validation in parent.
   validateInput
});

// eslint-disable-next-line
const emit = __emit;

let minNbFiles = computed(() => props.min != null ? props.min : 0);
let maxNbFiles = computed(() => props.max != null ? props.max : -1);

const defaultSelectedFiles = ref(props.defaultSelectedFiles);
watch(defaultSelectedFiles, (newValue) => emit("on-default-selected-files-change", newValue?.length ? newValue[0].toString() : "") , { deep: true, immediate: true });
watch(props, (newProps) => {
  defaultSelectedFiles.value = newProps.defaultSelectedFiles;
});

const status = ref<Status>({ valid: true });
const files = ref<Array<File>>();
const filesInput = ref<HTMLInputElement>();

let btnLabelKey = computed(() => {
  let isReplacing = (files.value && files.value.length > 0) || (defaultSelectedFiles.value && defaultSelectedFiles.value.length > 0);
  let isPlural = maxNbFiles.value > 1 || props.isMultiple || (files.value && files.value.length > 1);
  
  return `global.${isReplacing ? 'replace' : 'add'}File${isPlural ? 's' : ''}`
})

function removeFile(file: File) {
  if (files.value) {
    files.value = files.value.filter((f) => f != file);
    emit("update:modelValue", files.value);
  }

  validateInput()
}

function clearSavedFile(index: number) {
  defaultSelectedFiles.value?.splice(index, 1);
}

const hasChanged = ref(false)
function handleChange(e: Event) {
  const inputEl = e.target as HTMLInputElement;

  hasChanged.value = true;

  if (inputEl.files != null && inputEl.files.length > 0) {
    files.value = Array.from(inputEl.files);
  }

  validateInput();

  emit("update:modelValue", files.value);
}

async function validateInput() {
  await updateStatus();
  emit("validated", props.name, status.value);
}

async function updateStatus() {
  status.value = {
    valid: true,
    message: ""
  }

  if (minNbFiles.value > 0 && (files.value == null && props.defaultSelectedFiles == null || (files.value != null && files.value.length < minNbFiles.value))) {
    status.value = {
      valid: false,
      message: t("validation.fileMin", { min: minNbFiles.value, s: minNbFiles.value > 1 ? "s" : "" })
    }

    return
  }

  if (maxNbFiles.value > 0 && files.value != null && files.value.length > maxNbFiles.value) {
    status.value = {
      valid: false,
      message: t("validation.fileMax", { max: maxNbFiles.value, s: maxNbFiles.value > 1 ? "s" : "" })
    }

    return
  }

  if (props.possiblesTypes != null && props.possiblesTypes.length > 0 && files.value != null) {
    files.value.forEach(file => {
      if (!props.possiblesTypes?.includes(file.type)) {
        files.value = [];

        status.value = {
          valid: false,
          message: t("validation.fileType", {type: props.possiblesTypes?.toString().replaceAll("image/", " .")})
        }
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form__fields-container", { error: !status.value.valid }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        ref_key: "filesInput",
        ref: filesInput,
        type: "file",
        name: _ctx.name,
        id: _ctx.name,
        accept: _ctx.possiblesTypes?.toString(),
        multiple: _ctx.isMultiple,
        onChange: handleChange,
        onBlur: validateInput,
        "aria-invalid": !status.value.valid,
        "aria-describedby": `error__${_ctx.name}`
      }, null, 40, _hoisted_2),
      _createElementVNode("label", { for: _ctx.name }, [
        _createTextVNode(_toDisplayString(_ctx.label ? _ctx.label : _ctx.name) + " ", 1),
        (_unref(minNbFiles) > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
          : _createCommentVNode("", true),
        (_ctx.tooltip)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.tooltip), 1))
          : _createCommentVNode("", true),
        (_ctx.isMultiple || files.value?.length != 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(t)(_unref(btnLabelKey))) + " ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["plus-sign", { 'plus-sign--red': !status.value.valid }])
              }, null, 2)
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_3),
      (files.value != null && files.value.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file) => {
              return (_openBlock(), _createElementBlock("li", {
                key: file.name,
                class: "form-files__file"
              }, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(file.name), 1),
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeFile(file)),
                  class: "form-files__remove",
                  type: "button",
                  "aria-label": _unref(t)('global.removeFile')
                }, _hoisted_11, 8, _hoisted_9)
              ]))
            }), 128))
          ]))
        : (!hasChanged.value && (defaultSelectedFiles.value && defaultSelectedFiles.value.filter(x => x.toString().length).length > 0))
          ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultSelectedFiles.value, (file, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: file.toString(),
                  class: "form-files__file"
                }, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(file.toString().extractFileName()), 1),
                  (_ctx.canDelete)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (clearSavedFile(index)),
                        class: "form-files__remove",
                        type: "button",
                        "aria-label": _unref(t)('global.removeFile')
                      }, _hoisted_16, 8, _hoisted_14))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
    ]),
    (!status.value.valid)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "form__error-message",
          id: `error__${_ctx.name}`
        }, _toDisplayString(status.value.message), 9, _hoisted_17))
      : _createCommentVNode("", true)
  ], 2))
}
}

})